import { OrderDirection } from "_shared/_api/ordering/order-direction";

export enum PermissionOrderField {
  CreatedDate = "CreatedDate",
  DisabledDate = "DisabledDate",
  Resource = "Resource",
}

export type PermissionOrderParametersProps = {
  orderBy?: PermissionOrderField;
  orderDir?: OrderDirection;
};

export default class PermissionOrderParameters {
  public readonly orderBy?: PermissionOrderField;
  public readonly orderDir?: OrderDirection;

  public constructor(props: PermissionOrderParametersProps) {
    this.orderBy = props.orderBy;
    this.orderDir = props.orderDir;
  }

  public get searchParams(): URLSearchParams {
    const searchParams = new URLSearchParams();
    if (this.orderBy) searchParams.append("orderBy", this.orderBy);
    if (this.orderDir) searchParams.append("orderDir", this.orderDir);
    return searchParams;
  }

  public isEqualTo(other: PermissionOrderParameters | undefined): boolean {
    if (!other) return false;
    return this.orderBy === other.orderBy && this.orderDir === other.orderDir;
  }

  public toString(): string {
    return this.searchParams.toString();
  }
}
